import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  SingleAction,
  Sort,
  TabActionDialog
} from "../types";

export const currencyrateSection = "/currencyrate/";
export const currencyrateRefresh = "/currencyrate/#";

export const currencyrateListPath = currencyrateSection;

export enum CurrencyrateListUrlSortField {
  name = "name",
  symbol = "symbol",
  slug = "slug",
  rate = "rate",
  onlineRate = "onlineRate",
  updateDate = "updateDate",
  displayOrder = "displayOrder",
  isPublished = "isPublished"
}

export enum CurrencyrateListUrlFiltersEnum {
  isPrimaryStoreCurrency = "isPrimaryStoreCurrency",
  isPrimaryExchangeRateCurrency = "isPrimaryExchangeRateCurrency",
  isPublished = "isPublished",
  query = "query"
}
export type CurrencyrateListUrlDialog = "event-dialog"|"remove" | TabActionDialog;
export type CurrencyrateListUrlFilters = Filters<
  CurrencyrateListUrlFiltersEnum
>;
export type CurrencyrateListUrlSort = Sort<CurrencyrateListUrlSortField>;
export type CurrencyrateListUrlQueryParams = ActiveTab &
  CurrencyrateListUrlFilters &
  CurrencyrateListUrlSort &
  BulkAction &
  Dialog<CurrencyrateListUrlDialog> &
  Pagination;

export const currencyrateListUrl = (params?: CurrencyrateListUrlQueryParams) =>
  currencyrateListPath + "?" + stringifyQs(params);
export type CurrencyrateAddUrlDialog =
  | "add-value"
  | "edit-value"
  | "remove-value"
  | "remove-values";
export type CurrencyrateUrlDialog =
  | "add-value"
  | "edit-value"
  | "remove"
  | "remove-value"
  | "remove-values";
export type CurrencyrateAddUrlQueryParams = Dialog<CurrencyrateAddUrlDialog> &
  SingleAction;
export type CurrencyrateUrlQueryParams = BulkAction &
  Dialog<CurrencyrateUrlDialog> &
  SingleAction;
export const currencyrateAddPath = urlJoin(currencyrateSection, "add");

export const currencyrateAddUrl = (params?: CurrencyrateAddUrlQueryParams) =>
  currencyrateAddPath + "?" + stringifyQs(params);

export const currencyratePath = (id: string) =>
  urlJoin(currencyrateSection, id);
export const currencyrateUrl = (
  id: string,
  params?: CurrencyrateUrlQueryParams
) => currencyratePath(encodeURIComponent(id)) + "?" + stringifyQs(params);
